import { useEffect } from 'react';
import { ButtonType } from '../button';
import { NavigationAndActionClose } from '../icons';
import { ToggleButton } from '../toggleButton';
import { BodyText, HeadlineTitle } from '../typography';
import {
  StyledButton,
  StyledButtonContainer,
  StyledModalBackdrop,
  StyledModalContainer,
  StyledModalHeader,
  StyledModalTransitions,
  StyledTextContainer,
} from './styled';

export interface ModalProps {
  visible?: boolean;
  width?: string;
  height?: string;
  title?: string;
  text?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryAction?: () => void;
  secondaryAction?: () => void;
  onClose?: () => void;
}

export const Modal: React.FC<ModalProps> = ({
  visible = false,
  width,
  height,
  title,
  text,
  primaryButtonText,
  secondaryButtonText,
  primaryAction,
  secondaryAction,
  onClose,
  children,
  ...props
}) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [visible]);

  return (
    <StyledModalTransitions
      in={visible}
      timeout={400}
      classNames="modal"
      onExited={onClose}
      unmountOnExit>
      <StyledModalBackdrop className="full-width-container">
        <StyledModalContainer width={width} height={height} {...props}>
          <StyledModalHeader>
            <HeadlineTitle>{title}</HeadlineTitle>
            <div>
              <ToggleButton
                onClick={onClose}
                icon={<NavigationAndActionClose />}
              />
            </div>
          </StyledModalHeader>
          <StyledTextContainer>
            {text && <BodyText>{text}</BodyText>}
            {children}
          </StyledTextContainer>
          <StyledButtonContainer>
            {secondaryButtonText && (
              <StyledButton
                type={ButtonType.Secondary}
                text={secondaryButtonText}
                onClick={secondaryAction}
              />
            )}
            <StyledButton
              type={ButtonType.Primary}
              text={primaryButtonText}
              onClick={primaryAction}
            />
          </StyledButtonContainer>
        </StyledModalContainer>
      </StyledModalBackdrop>
    </StyledModalTransitions>
  );
};
